import './scss/all.combined.scss'
// This is needed in case older browsers don't work
// import 'vite/modulepreload-polyfill'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import { cmsService } from '@/content/services/cms.service'
import { initServices } from '@/content/services/init'
import { App } from './App'
import { mobileEmbedService } from './content/services/mobileEmbed/mobileEmbed.service'
import { init } from './init'

window.loadMs = Date.now()

initServices()

if (mobileEmbedService.isMobileApp()) {
    // Offset modals below the 44px app header. Uses react-aria's --visual-viewport-height variable.
    const style = document.createElement('style')
    style.innerHTML =
        '.v-modal { top: 44px; height: calc(var(--visual-viewport-height, 100%) - 44px); };#root{padding-bottom: env(safe-area-inset-bottom, 0px);}'
    document.head.appendChild(style)

    // Ensure no weird scaling happens in mobile embed
    try {
        const meta = document.createElement('meta')
        meta.name = 'viewport'
        meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
        document.getElementsByTagName('head')[0].appendChild(meta)
    } catch {
        /* empty */
    }
}

cmsService.initialize().then(
    occConfigurationApi => {
        /**
         * Avoid placing any before-render scripts into this function.
         * Instead, run them in the below `init()` function to allow parity in automated test via storybook.
         */

        init(occConfigurationApi)

        const rootDiv = document.getElementById('root')
        if (rootDiv) {
            const root = createRoot(rootDiv)
            root.render(createElement(App))
        }
    },
    _ => {}
)
